<template>
  <v-card>
    <v-card-title>
      <span>
        <v-icon>mdi-image-area</v-icon> Copertina
      </span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-img
        :src="url"
        v-if="url != null && url.length !== 0"
      ></v-img>
      <v-img
        src="http://kmdi.utoronto.ca/wp-content/themes/oria/images/placeholder.png"
        v-else
      ></v-img>
    </v-card-text>
    <v-card-text>
      <v-text-field
        outlined
        label="URL immagine"
        v-model="url"
      ></v-text-field>
    </v-card-text>
  </v-card>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ArticleCover',
    data() {
      return {
        url: '',
      }
    },
    computed: {
      ...mapGetters([
        'newArticle'
      ])
    },
    watch: {
      url(val) {
        this.$store.commit('SET_ARTICLE_BANNER_URL', val)
      },
      newArticle: {
        handler(val) {
          this.url = val.bannerUrl
        },
        deep: true
      }
    },
    beforeMount() {
      this.url = this.newArticle.bannerUrl || ''
    }
  }
</script>